import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import {
  catchError,
  distinctUntilChanged,
  EMPTY,
  filter,
  map,
  switchMap,
  take,
} from 'rxjs';

import { EAccessCode } from '@app/app.enums';
import { MetroMapApiService } from '@app/core/api/metro-map-api.service';
import { selectAuth } from '@app/features/auth/auth.selectors';

@Injectable({ providedIn: 'root' })
export class MetroMapPreloadService {
  private readonly api = inject(MetroMapApiService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly store = inject(Store);
  private started = false;

  public start(): void {
    if (this.started) {
      return;
    }

    this.started = true;
    this.store
      .select(selectAuth)
      .pipe(
        map(
          (auth) =>
            auth.init &&
            auth.accessStatus === 'ready' &&
            !auth.sessionTransitioning &&
            auth.access.includes(EAccessCode.s_MetroMap),
        ),
        distinctUntilChanged(),
        filter(Boolean),
        take(1),
        switchMap(() => this.api.getMetroMap().pipe(catchError(() => EMPTY))),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}

export function metroMapPreloadInitializer(): void {
  inject(MetroMapPreloadService).start();
}
